import { useCallback, useMemo } from 'react';
import { useRedirect } from '../../hooks/useRedirect';
import routes from '../../routes/constants';
import useQueryParam from './useQueryParam';

export const MAP_ID_STORAGE_KEY = 'map_redirect_id';

const useRedirectToMap = () => {
  const redirect = useRedirect();
  const map2dId = useQueryParam('mp', {
    parse: (value: string) => {
      const parsed = Number.parseInt(value, 10);
      return !Number.isNaN(parsed) && parsed > 0 ? parsed : undefined;
    },
  });

  const redirectToMap = useCallback(async () => {
    try {
      if (map2dId) {
        redirect.push(routes.mp.map2d(map2dId), {
          preserveQueryParams: false,
        });
      } else {
        redirect.goBack();
      }
    } catch (error) {
      redirect.goBack();
    }
  }, [redirect, map2dId]);

  return useMemo(() => ({ map2dId, redirectToMap }), [map2dId, redirectToMap]);
};

export default useRedirectToMap;
